export const VALIDATE_VOE_OPT_OUT_TOKEN = gql`
  query ValidateVoEOptOutToken($voeId: String!, $token: String!) {
    validateVoEOptOutToken(voeId: $voeId, token: $token) {
      valid
      suppressedScope
      carrierName
      dotNumber
      maskedEmail
      canScopeToCarrier
    }
  }
`

export const SUBMIT_VOE_OPT_OUT = gql`
  mutation SubmitVoEOptOut($input: SubmitVoEOptOutInput!) {
    submitVoEOptOut(input: $input)
  }
`
